
import { Calendar, Filter, Search, Download, IndianRupee } from "lucide-react"

export default function BillsReceipts() {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title">
          <IndianRupee />
          <h1>Bills & Receipts</h1>
        </div>
      </div>

      <div className="search-container">
        <div className="search-input">
          <Search className="search-icon" />
          <input type="text" placeholder="Search documents..." />
        </div>
        <div className="filter-group">
          <button className="filter-button">
            <Filter />
            <span>Filter by Hospital</span>
          </button>
          <button className="filter-button">
            <Calendar />
            <span>Filter by Date</span>
          </button>
        </div>
      </div>

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Date</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Hospital Stay</td>
              <td>7/20/2023</td>
              <td>
                <Download className="download-icon" />
              </td>
            </tr>
            <tr>
              <td>Outpatient Procedure</td>
              <td>9/15/2023</td>
              <td>
                <Download className="download-icon" />
              </td>
            </tr>
            <tr>
              <td>Consultation Fee</td>
              <td>10/5/2023</td>
              <td>
                <Download className="download-icon" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

